import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import ProtocolsDetails from "../../components/Protocols/ProtocolsDetails";
import Paper from "@material-ui/core/Paper/Paper";

const ProtocolsShow = ({}) => (
    <React.Fragment>
        <ProtocolsDetails />
    </React.Fragment>
);

export default ProtocolsShow;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/protocols/Show.jsx